module.exports = __webpack_public_path__ + "img/img8.7fcfaeeb.png";